import React from 'react';
import logo from './logo.svg';
import demi from './Demi.png'
import building from './denver3d.png';
import Tilt from "react-tilt";
import IG from "./IG.png";
import twodimone from "./2d_1.png";
import twodimtwo from "./2d_2.png";
import threedimone from "./3d_1.png";
import threedimtwo from "./3d_2.png";
import gallery1 from "./gallery1.png";
import gallery2 from "./gallery2.png";
import gallery3 from "./gallery3.png"
import Pinterest from "./pinterest.png";
import { MobileView, BrowserView } from "react-device-detect";
import { Box } from '@material-ui/core';


import './App.css';

function App() {

  return (
    <div className="App" style={{ padding: "env(safe-area-inset-top) env(safe-area-inset-right) env(safe-area-inset-bottom) env(safe-area-inset-left);" }}>

      <BrowserView>
        <Box className="section" width="100%" height="100vh" overflow="hidden" display="flex" flexDirection="column" justifyContent="space-between" style={{ backgroundColor: "#4472c4" }} alignItems="center">
          <Box display="flex" width="100%" flexDirection="row" fontSize="30px" fontFamily="arial-narrow" height="24vh" justifyContent="space-around" flexWrap="wrap">
            <Box flex={1} display="flex" flexDirection="column" justifyContent="center">
              <h1 style={{ whiteSpace: "nowrap", margin: 0, padding: 0, color: "#ffffff" }}>Demi Sweijen</h1>
            </Box>
            <div flex={2} style={{ borderRadius: "50%", backgroundColor: "#ffffff", height: "20vh", width: "20vh", border: "solid 1vh #4472c4", boxShadow: "0 0 0 1vh #ffffff", maxWidth: "90vw", marginTop: "2vh" }} >
              <img src={logo} alt="Logo Demi Sweijen Interieurontwerp, interieurstyling in Zwanenburg, Haarlem, Amsterdam en omgeving" style={{ height: "80%", width: "80%", marginTop: "10%" }} />
            </div>
            <Box flex={1} display="flex" flexDirection="column" justifyContent="center">
              <h1 style={{ margin: 0, padding: 0, color: "#ffffff" }}>Interieurontwerp</h1>
            </Box>
          </Box>
          <Box display="flex" flexDirection="row" justifyContent="center" paddingBottom="3vh">
            <div style={{ borderRadius: "50%", backgroundColor: "#ffffff", height: "65vh", width: "65vh", border: "solid 1vh #4472c4", boxShadow: "0 0 0 1vh #ffffff", maxWidth: "90vw" }} >
              <Tilt style={{ height: "100%", width: "100%" }} options={{ scale: 1 }}>
                <img src={building} alt="3D ontwerp huis met woonkamer, keuken, slaapkamer, badkamer, met styling en meubels" style={{ height: "85%", width: "auto", marginTop: "10%" }} />
              </Tilt>
            </div>
          </Box>
        </Box>
      </BrowserView>
      <MobileView>
        <Box className="section" width="100%" minHeight="100vh" overflow="hidden" display="flex" flexDirection="column" justifyContent="space-between" style={{ backgroundColor: "#4472c4" }} alignItems="center" justifyContent="space-around">

          <div flex={1} style={{ borderRadius: "50%", backgroundColor: "#ffffff", height: "15vh", width: "15vh", border: "solid 1vh #4472c4", boxShadow: "0 0 0 1vh #ffffff", maxWidth: "90vw", marginTop: "2vh" }} >
            <img src={logo} alt="Logo Demi Sweijen Interieurontwerp, interieurstyling in Zwanenburg, Haarlem, Amsterdam en omgeving" style={{ height: "80%", width: "80%", marginTop: "10%" }} />
          </div>
          <Box flex={1} display="flex" flexDirection="column" justifyContent="center">
            <h1 style={{ whiteSpace: "nowrap", margin: 0, padding: 0, color: "#ffffff" }}>Demi Sweijen</h1>
            <h1 style={{ margin: 0, padding: 0, color: "#ffffff" }}>Interieurontwerp</h1>
          </Box>
          <Box flex={2} display="flex" flexDirection="row" justifyContent="center" paddingBottom="3vh">
            <div style={{ borderRadius: "50%", backgroundColor: "#ffffff", height: "90vw", width: "90vw", maxHeight: "50vh", maxWidth: "50vh", border: "solid 1vh #4472c4", boxShadow: "0 0 0 1vh #ffffff" }} >
              <Tilt style={{ height: "100%", width: "100%" }} options={{ scale: 1 }}>
                <img src={building} alt="3D ontwerp huis met woonkamer, keuken, slaapkamer, badkamer, met styling en meubels" style={{ height: "85%", width: "auto", marginTop: "10%" }} />
              </Tilt>
            </div>
          </Box>
        </Box>
      </MobileView>

      <BrowserView>
        <Box className="section" display="flex" flexDirection="column" justifyContent="center" width="100%" bgcolor="#ffffff">
          <h1 style={{ color: "#4472c4", fontSize: "5vh" }}>Over mij</h1>
          <Box display="flex" flexDirection="row" minHeight="70vh" justifyContent="space-between" flexWrap="wrap" marginTop="5vh" marginBottom="5vh">

            <Box display="flex" flexDirection="row" justifyContent="start" minWidth="350px">
              <div style={{ display: "flex", flexDirection: "row", justifyContent: "left", borderTopRightRadius: "70vh", borderBottomRightRadius: "70vh", backgroundColor: "#4472c4", height: "70vh", width: "35vh", border: "solid 1vh #ffffff", borderLeftStyle: "none", boxShadow: "0 0 0 1vh #4472c4, 20px 20px 15px grey", maxWidth: "40vw", marginLeft: "0", minHeight: "600px", minWidth: "300px" }} >
                <img src={demi} alt="Demi Sweijen, afgestudeerd interieur ontwerpster, eigenaresse van Demi Sweijen interieurontwerp" style={{ borderTopRightRadius: "60vh", borderBottomRightRadius: "60vh", height: "60vh", maxWidth: "100%", marginLeft: "0", alignSelf: "center" }} />
              </div>
            </Box>

            <Box display="flex" flexDirection="column" justifyContent="center">
              <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", borderRadius: "50%", backgroundColor: "#4472c4", height: "45vh", width: "45vh", border: "solid 1vh #ffffff", boxShadow: "0 0 0 1vh #4472c4, 20px 20px 15px grey", maxWidth: "40vw", minHeight: "500px", minWidth: "500px", marginLeft: "2vw" }} >
                <Box padding="10%">
                  <h1 style={{ color: "#fff", fontSize: "2.4vh" }}>
                    Mijn naam is Demi Sweijen.
                </h1>
                  <h2 style={{ color: "#fff", fontSize: "1.9vh" }}>
                    Jong, hip en enorm gedreven! <br />In 2020 ben ik afgestudeerd als interieuradviseur aan het Hout- en Meubileringscollege.
                </h2>
                  <h2 style={{ color: "#fff", fontSize: "1.9vh" }}>
                    Voor verschillende stijlen en wensen draai ik mijn hand niet om. Vooral het maken van 3D ontwerpen is mijn specialiteit.
                </h2>
                  <h1 style={{ color: "#fff", fontSize: "2.4vh" }}>
                    Mag ik u helpen?
                </h1>
                </Box>
              </div>
            </Box>
            <Box display="flex" flexDirection="column" justifyContent="center">
              <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", borderRadius: "50%", backgroundColor: "#4472c4", height: "35vh", width: "35vh", border: "solid 1vh #ffffff", boxShadow: "0 0 0 1vh #4472c4, 20px 20px 15px grey", maxWidth: "40vw", minHeight: "400px", minWidth: "400px", marginRight: "1vw", marginLeft: "1vw" }} >
                <Box padding="5%">
                  <h1 style={{ color: "#fff" }}>
                    Contact:
                </h1>
                  <h2 style={{ color: "#fff" }}>
                    <a href="mailto:dsinterieurontwerp@gmail.com">dsinterieurontwerp@gmail.com</a>
                  </h2>
                  <h1 style={{ color: "#fff" }}>
                    Social Media:
                </h1>
                  <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-around" }}>
                    <div style={{ backgroundColor: "#ffffff", padding: "10px", borderRadius: "30px" }}>
                      <a href="https://instagram.com/demi_sweijen_interieurontwerp" target="_blank"><img style={{ height: "7vh", width: "7vh" }} src={IG} alt="Instagram" /></a>
                    </div>
                    <div style={{ backgroundColor: "#ffffff", padding: "10px", borderRadius: "30px" }}>
                      <a href="https://pinterest.com/demisweijen14/" target="_blank"><img style={{ height: "7vh", width: "7vh" }} src={Pinterest} alt="Pinterest" /></a>
                    </div>
                  </div>
                </Box>
              </div>
            </Box>
          </Box>
        </Box>
      </BrowserView>

      <MobileView>
        <Box display="flex" flexDirection="column" justifyContent="space-between" width="100%" bgcolor="#ffffff">
          <h1 style={{ color: "#4472c4", fontSize: "5vh" }}>Over mij</h1>
          <Box display="flex" flexDirection="row" justifyContent="space-between" flexWrap="wrap">
            <Box display="flex" flexDirection="row" justifyContent="start" minWidth="350px">
              <div style={{ display: "flex", flexDirection: "row", justifyContent: "left", borderTopRightRadius: "70vh", borderBottomRightRadius: "70vh", backgroundColor: "#4472c4", height: "70vh", width: "35vh", border: "solid 1vh #ffffff", borderLeftStyle: "none", boxShadow: "0 0 0 1vh #4472c4, 20px 20px 15px grey", marginLeft: "0", minHeight: "600px", minWidth: "300px" }} >
                <img src={demi} alt="Demi Sweijen, afgestudeerd interieur ontwerpster, eigenaresse van Demi Sweijen interieurontwerp" style={{ borderTopRightRadius: "60vh", borderBottomRightRadius: "60vh", height: "60vh", maxWidth: "100%", marginLeft: "0", alignSelf: "center", minHeight: "500px", minWidth: "250px" }} />
              </div>
            </Box>
            <Box display="flex" flexDirection="column" justifyContent="space-between" flexWrap="wrap">
              <Box display="flex" flexDirection="row" justifyContent="center" minWidth="50vw">
                <Box display="flex" flexDirection="column" justifyContent="center">
                  <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", borderRadius: "50%", backgroundColor: "#4472c4", height: "90vw", width: "90vw", border: "solid 1vh #ffffff", boxShadow: "0 0 0 1vh #4472c4, 20px 20px 15px grey", alignSelf: "center", marginBottom: "5vh", maxHeight: "80vh", maxWidth: "80vh", marginLeft:"1.5vh"}} >
                    <Box padding="10%">
                      <h1 style={{ color: "#fff", fontSize: "max(2.4vh, 18px)" }}>
                        Mijn naam is Demi Sweijen.
                </h1>
                      <h2 style={{ color: "#fff", fontSize: "max(1.9vh, 10px)" }}>
                        Jong, hip en enorm gedreven!<br />In 2020 ben ik afgestudeerd als interieuradviseur aan het Hout- en Meubileringscollege.
                </h2>
                      <h2 style={{ color: "#fff", fontSize: "max(1.9vh, 10px)" }}>
                        Voor verschillende stijlen en wensen draai ik mijn hand niet om. Vooral het maken van 3D ontwerpen is mijn specialiteit.
                </h2>
                      <h1 style={{ color: "#fff", fontSize: "max(2.4vh, 18px)" }}>
                        Mag ik u helpen?
                </h1>
                    </Box>
                  </div>
                </Box>
              </Box>
              <Box display="flex" flexDirection="row" justifyContent="center">
              <Box display="flex" flexDirection="column" justifyContent="center">
                <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", borderRadius: "50%", backgroundColor: "#4472c4", height: "90vw", width: "90vw", border: "solid 1vh #ffffff", boxShadow: "0 0 0 1vh #4472c4, 20px 20px 15px grey", alignSelf: "center", marginBottom: "5vh", maxHeight: "80vh", maxWidth: "80vh", marginLeft:"1.5vh" }} >
                  <Box padding="5%">
                    <h1 style={{ color: "#fff" }}>
                      Contact:
                </h1>
                    <h2 style={{ color: "#fff", fontSize: "max(2.4vh, 18px)" }}>
                      <a href="mailto:dsinterieurontwerp@gmail.com">dsinterieurontwerp@gmail.com</a>
                    </h2>
                    <h1 style={{ color: "#fff" }}>
                      Social Media:
                </h1>
                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-around" }}>
                      <div style={{ backgroundColor: "#ffffff", padding: "10px", borderRadius: "30px" }}>
                        <a href="https://instagram.com/demi_sweijen_interieurontwerp" target="_blank"><img style={{ height: "7vh", width: "7vh" }} src={IG} alt="Instagram" /></a>
                      </div>
                      <div style={{ backgroundColor: "#ffffff", padding: "10px", borderRadius: "30px" }}>
                        <a href="https://pinterest.com/demisweijen14/" target="_blank"><img style={{ height: "7vh", width: "7vh" }} src={Pinterest} alt="Pinterest" /></a>
                      </div>
                    </div>
                  </Box>
                </div>
              </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </MobileView>


      <BrowserView>
        <Box height="80vh" width="100%" style={{ background: "linear-gradient(#4472c4 50%, #FFFFFF 50%)" }} display="flex" flexDirection="column" justifyContent="space-between">
          <h1 style={{ color: "#ffffff", fontSize: "5vh", height: "5vh" }}>Inspiratie</h1>
          <Box display="flex" flexDirection="row" justifyContent="space-around">
            <img style={{ height: "35vh", border: "solid #ffffff 1vh", boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)" }} src={gallery1} alt="Persoonlijk stijladvies met verschillende stoffen, verf, kleuren, materialen, vloer" />
            <img style={{ height: "35vh", border: "solid #ffffff 1vh", boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)" }} src={gallery2} alt="Moodboard met kleuren vloer, muren, advies voor meubels, waaronder bank, stoel en kast" />
            <img style={{ height: "35vh", border: "solid #ffffff 1vh", boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)" }} src={gallery3} alt="Advies accessoires om interieur mooi te maken, vasen, mandjes, bloemen en planten" />
          </Box>
          <h1 fontSize="5vh"> </h1>
        </Box>
      </BrowserView>

      <MobileView>
        <Box width="100%" style={{ backgroundColor: "#4472c4" }} display="flex" flexDirection="column" justifyContent="space-between">
          <h1 style={{ color: "#ffffff", fontSize: "5vh", height: "5vh", backgroundColor: "" }}>Inspiratie</h1>
          <Box display="flex" flexDirection="column" justifyContent="space-around" style={{ background: "linear-gradient(90deg, #4472c4 10%, #FFFFFF 10%, #FFFFFF 90%, #4472c4 90%)", marginTop: "5vh", alignSelf:"center"}}>
            <img style={{ width:"96vw", maxWidth:"80vh", border: "solid #ffffff 1vh", boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)", marginBottom: "5vh" }} src={gallery1} alt="Persoonlijk stijladvies met verschillende stoffen, verf, kleuren, materialen, vloer" />
            <img style={{ width:"96vw", maxWidth:"80vh", border: "solid #ffffff 1vh", boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)", marginBottom: "5vh" }} src={gallery2} alt="Moodboard met kleuren vloer, muren, advies voor meubels, waaronder bank, stoel en kast" />
            <img style={{ width:"96vw", maxWidth:"80vh", border: "solid #ffffff 1vh", boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)", marginBottom: "5vh" }} src={gallery3} alt="Advies accessoires om interieur mooi te maken, vasen, mandjes, bloemen en planten" />
          </Box>
          <div style={{ height: "10vh", backgroundColor: "#ffffff" }} />
        </Box>
      </MobileView>




      <Box className="section" width="100%" minHeight="100vh" bgcolor="#4472c4" display="flex" flexDirection="column" justifyContent="space-between">
        <h1 style={{ color: "#ffffff", fontSize: "5vh" }}>Pakketten</h1>
        <h2 style={{ color: "#ffffff", fontSize: "3vh", width: "70%", alignSelf: "center", marginBottom: "60px" }}>Opzoek naar dé nieuwe stijl voor uw kamer of huis, of misschien nieuwe accessoires om alles weer op te fleuren? Mail mij voor meer informatie of een afspraak inplannen.</h2>
        <Box display="flex" flexDirection="row" justifyContent="space-around" flexWrap="wrap">
          <div style={{ backgroundColor: "#ffffff", height: "40vh", width: "15vw", borderRadius: "60px", border: "solid 1vh #4472c4", boxShadow: "0 0 0 1vh #ffffff, 20px 20px 15px darkblue", display: "flex", flexDirection: "column", justifyContent: "space-between", minWidth: "280px", minHeight: "420px", margin: "10px", marginBottom: "4vh" }}>
            <div style={{ height: "15%", borderBottom: "solid 1vh #4472c4", display: "flex", flexDirection: "column", justifyContent: "center" }}>
              <h2 className="pakketHeader" style={{ color: "#4472c4" }}>Online Kleuradvies</h2>
            </div>
            <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-around", alignSelf: "start", marginLeft: "20px", textAlign: "left" }}>
              <h3 style={{ color: "#4472c4" }}>Plattegrond kleurindeling</h3>
              <h3 style={{ color: "#4472c4" }}>Kleurcodes</h3>
              <h3 style={{ color: "#4472c4" }}>Wandaanzicht</h3>
            </div>
            <div style={{ height: "15%", borderTop: "solid 1vh #4472c4", display: "flex", flexDirection: "column", justifyContent: "center" }}>
              <h2 className="pakketHeader" style={{ color: "#4472c4" }}>€60</h2>
            </div>
          </div>
          <div style={{ backgroundColor: "#ffffff", height: "40vh", width: "15vw", borderRadius: "60px", border: "solid 1vh #4472c4", boxShadow: "0 0 0 1vh #ffffff, 20px 20px 15px darkblue", display: "flex", flexDirection: "column", justifyContent: "space-between", minWidth: "280px", minHeight: "420px", margin: "10px", marginBottom: "4vh" }}>
            <div style={{ height: "15%", borderBottom: "solid 1vh #4472c4", display: "flex", flexDirection: "column", justifyContent: "center" }}>
              <h2 className="pakketHeader" style={{ color: "#4472c4" }}>Stylingadvies</h2>
            </div>
            <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-around", alignSelf: "start", marginLeft: "20px" }}>
              <h3 style={{ color: "#4472c4" }}>Accessoiresvoorstel</h3>
              <h3 style={{ color: "#4472c4" }}>Totale shoppinglist</h3>
            </div>
            <div style={{ height: "15%", borderTop: "solid 1vh #4472c4", display: "flex", flexDirection: "column", justifyContent: "center" }}>
              <h2 className="pakketHeader" style={{ color: "#4472c4" }}>€100</h2>
            </div>
          </div>
          <div style={{ backgroundColor: "#ffffff", height: "40vh", width: "15vw", borderRadius: "60px", border: "solid 1vh #4472c4", boxShadow: "0 0 0 1vh #ffffff, 20px 20px 15px darkblue", display: "flex", flexDirection: "column", justifyContent: "space-between", minWidth: "280px", minHeight: "420px", margin: "10px", marginBottom: "4vh" }}>
            <div style={{ height: "15%", borderBottom: "solid 1vh #4472c4", display: "flex", flexDirection: "column", justifyContent: "center" }}>
              <h2 className="pakketHeader" style={{ color: "#4472c4" }}>Herindeling + stijl</h2>
            </div>
            <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-around", alignSelf: "start", marginLeft: "20px", textAlign: "left" }}>
              <h3 style={{ color: "#4472c4" }}>3 indelingen</h3>
              <h3 style={{ color: "#4472c4" }}>Kleuradvies</h3>
              <h3 style={{ color: "#4472c4" }}>Meubelvoorstel</h3>
              <h3 style={{ color: "#4472c4" }}>Stylingadvies</h3>
            </div>
            <div style={{ height: "15%", borderTop: "solid 1vh #4472c4", display: "flex", flexDirection: "column", justifyContent: "center" }}>
              <h2 className="pakketHeader" style={{ color: "#4472c4" }}>€220</h2>
            </div>
          </div>
          <div style={{ backgroundColor: "#ffffff", height: "40vh", width: "15vw", borderRadius: "60px", border: "solid 1vh #4472c4", boxShadow: "0 0 0 1vh #ffffff, 20px 20px 15px darkblue", display: "flex", flexDirection: "column", justifyContent: "space-between", minWidth: "280px", minHeight: "420px", margin: "10px", marginBottom: "4vh" }}>
            <div style={{ height: "15%", borderBottom: "solid 1vh #4472c4", display: "flex", flexDirection: "column", justifyContent: "center" }}>
              <h2 className="pakketHeader" style={{ color: "#4472c4" }}>Kamer compleet</h2>
            </div>
            <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-around", alignSelf: "start", marginLeft: "20px", textAlign: "left" }}>
              <h3 style={{ color: "#4472c4" }}>2 moodboards</h3>
              <h3 style={{ color: "#4472c4" }}>3 indelingen</h3>
              <h3 style={{ color: "#4472c4" }}>Plattegrond met indeling</h3>
              <h3 style={{ color: "#4472c4" }}>Meubelvoorstel</h3>
              <h3 style={{ color: "#4472c4" }}>Accessoiresvoorstel</h3>
              <h3 style={{ color: "#4472c4" }}>Verlichtingsvoorstel</h3>
              <h3 style={{ color: "#4472c4" }}>Kleur- en materialenvoorstel</h3>
              <h3 style={{ color: "#4472c4" }}>3D ontwerp</h3>
              <h3 style={{ color: "#4472c4" }}>Totale shoppinglist</h3>
              <h3 style={{ color: "#4472c4" }}>Eindpresentatie</h3>            </div>
            <div style={{ height: "15%", borderTop: "solid 1vh #4472c4", display: "flex", flexDirection: "column", justifyContent: "center" }}>
              <h2 className="pakketHeader" style={{ color: "#4472c4" }}>€1200</h2>
            </div>
          </div>
          <div style={{ backgroundColor: "#ffffff", height: "40vh", width: "15vw", borderRadius: "60px", border: "solid 1vh #4472c4", boxShadow: "0 0 0 1vh #ffffff, 20px 20px 15px darkblue", display: "flex", flexDirection: "column", justifyContent: "space-between", minWidth: "280px", minHeight: "420px", margin: "10px", marginBottom: "4vh" }}>
            <div style={{ height: "15%", borderBottom: "solid 1vh #4472c4", display: "flex", flexDirection: "column", justifyContent: "center" }}>
              <h2 className="pakketHeader" style={{ color: "#4472c4" }}>Maatwerk</h2>
            </div>
            <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-around", alignSelf: "start", marginLeft: "20px", textAlign: "left" }}>
              <h3 style={{ color: "#4472c4" }}>Zakelijk interieuradvies</h3>
              <h3 style={{ color: "#4472c4" }}>Vastgoedstyling</h3>
              <h3 style={{ color: "#4472c4" }}>Winkelstyling</h3>
            </div>
            <div style={{ height: "15%", borderTop: "solid 1vh #4472c4", display: "flex", flexDirection: "column", justifyContent: "center" }}>
              <h2 className="pakketHeader" style={{ color: "#4472c4" }}>Prijs op aanvraag</h2>
            </div>
          </div>
        </Box>
        <div style={{ backgroundColor: "#4472c4" }}>
        </div>
      </Box>


      <BrowserView>
        <Box className="section" height="100vh" display="flex" flexDirection="column" justifyContent="space-around" width="100%" bgcolor="#ffffff">
          <h1 style={{ color: "#4472c4", fontSize: "5vh" }}>Projecten</h1>
          <Box display="flex" flexDirection="row" justifyContent="space-around">
            <img style={{ height: "35vh", border: "solid #ffffff 1vh", boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)" }} src={threedimone} alt="3D ontwerp woonkamer in modern chique stijl met kleur, design meubelen, openhaard" />
            <img style={{ height: "35vh", border: "solid #ffffff 1vh", boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)" }} src={twodimone} alt="2D plattegrond, ingedeeld met nieuwe meubels, computer getekend, schuifraam" />
          </Box>
          <Box display="flex" flexDirection="row" justifyContent="space-around">
            <img style={{ height: "35vh", border: "solid #ffffff 1vh", boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)" }} src={twodimtwo} alt="Advies van materialen, vloeren en kleuren voor moderne stijl woonkamer of slaapkamer" />
            <img style={{ height: "35vh", border: "solid #ffffff 1vh", boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)" }} src={threedimtwo} alt="3D ontwerp eetkamer en keuken, lichte stijl met design lamp, gestyled" />
          </Box>
        </Box>
      </BrowserView>


      <MobileView>
        <Box className="section" display="flex" flexDirection="column" justifyContent="space-around" bgcolor="#ffffff" alignItems="center">
          <h1 style={{ color: "#4472c4", fontSize: "5vh" }}>Projecten</h1>
          <img style={{ width:"96vw", maxWidth:"80vh", border: "solid #ffffff 1vh", boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)", marginBottom: "5vh" }} src={threedimone} alt="3D ontwerp woonkamer in modern chique stijl met kleur, design meubelen, openhaard" />
          <img style={{ width:"96vw", maxWidth:"80vh", border: "solid #ffffff 1vh", boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)", marginBottom: "5vh" }} src={twodimone} alt="2D plattegrond, ingedeeld met nieuwe meubels, computer getekend, schuifraam" />

          <img style={{ width:"96vw", maxWidth:"80vh", border: "solid #ffffff 1vh", boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)", marginBottom: "5vh" }} src={twodimtwo} alt="Advies van materialen, vloeren en kleuren voor moderne stijl woonkamer of slaapkamer" />
          <img style={{ width:"96vw", maxWidth:"80vh", border: "solid #ffffff 1vh", boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)", marginBottom: "5vh" }} src={threedimtwo} alt="3D ontwerp eetkamer en keuken, lichte stijl met design lamp, gestyled" />
        </Box>
      </MobileView>

      <div style={{ backgroundColor: "#4472c4" }}>
        <p style={{ color: "#ffffff", fontSize: "1.4em", margin: "0", padding: "5px" }}>Contact: <a style={{ color: "#ffffff" }} href="mailto:dsinterieurontwerp@gmail.com">dsinterieurontwerp@gmail.com</a></p>
      </div>
    </div >
  );
}

export default App;

/*
<Box display="flex" flexDirection="column" justifyContent="space-between" height="90vh" marginTop="5vh" paddingLeft="5vw">
          <div style={{display: "flex", flexDirection:"column", justifyContent:"center", borderRadius: "50%", backgroundColor: "#4472c4", height:"35vh", width: "35vh", border: "solid 1vh #ffffff", boxShadow: "0 0 0 1vh #4472c4", maxWidth:"40vw"}} >
            <h2 style={{color: "#ffffff"}}>Een knap interieur voor elk budget</h2>
          </div>
          <div style={{borderRadius: "50%", backgroundColor: "#4472c4", height:"35vh", width: "35vh", border: "solid 1vh #ffffff", boxShadow: "0 0 0 1vh #4472c4", maxWidth:"40vw"}} >
          </div>
          </Box>
          <Box display="flex" flexDirection="column" justifyContent="center" height="90vh" marginTop="5vh" paddingRight="5vw">
          <div style={{borderRadius: "50%", backgroundColor: "#4472c4", height:"35vh", width: "35vh", border: "solid 1vh #ffffff", boxShadow: "0 0 0 1vh #4472c4", maxWidth:"40vw"}} >
          </div>
          </Box>





*/
